import { checkLocationAndStoreId, checkUserSegments } from './segmentationUtil';

interface ShouldShowGoldProps {
  goldConfig?: number[];
  product?: {
    applicable_brand_specials_excluded_user_segments?: number[] | -1 | null;
    applicable_brand_specials_included_user_segments?: number[] | -1 | null;
  };
  store?: {
    id: number;
  };
  userSegments?: number[];
}

export const getShouldShowGold = ({
  goldConfig,
  product,
  store,
  userSegments,
}: ShouldShowGoldProps): boolean => {
  const validSegments = checkUserSegments({
    product,
    userSegments: userSegments || [],
  });

  if (goldConfig) {
    const validState = checkLocationAndStoreId(goldConfig, store);
    return validState && validSegments;
  }

  return validSegments;
};
